import * as React from 'react';
import { Button, Label, Panel } from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';
import Note from './note';
import { IMicrositeRecipientCommunication } from '@nkr/models/index';
import { MicrositeRecipientCommunicationStatus } from '@nkr/enums/index';

interface IProps {
    list: IMicrositeRecipientCommunication[],
    recipientName: string,
    recipientActive: boolean,
    onSendNote: (text: string, isReply: boolean, itemId: number) => void
}

interface IState {
    isExpanded: boolean
    note: {
        show: boolean,
        isReply: boolean,
        itemId: number
    }
}

class Communication extends React.Component<IProps, IState> {
    readonly state: IState = {
        isExpanded: true,
        note: {
            show: false,
            isReply: true,
            itemId: 0
        }
    }

    handleShowNewNote = () => {
        this.setState({
            isExpanded: true,
            note: {
                show: true,
                isReply: false,
                itemId: 0
            }
        });
    }

    handleShowReply = (itemId: number) => {
        this.setState({
            note: {
                show: true,
                isReply: true,
                itemId
            }
        });
    }

    handleCancelNote = () => {
        this.setState({
            note: { ...this.state.note, show: false }
        });
    }

    handleSendNote = (text: string) => {
        let { itemId, isReply } = this.state.note;

        this.setState({
            note: { ...this.state.note, show: false }
        }, () => {
            this.props.onSendNote(text, isReply, itemId);
        });
    }

    handleExpansion = () => {
        this.setState({
            isExpanded: !this.state.isExpanded
        });
    }

    render = () => {
        const fullName = this.props.recipientName;

        return (
            <Panel style={{ height: '50vh', overflow: 'scroll' }}>
                <Panel.Heading style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Panel.Title>Conversation</Panel.Title>
                    <Button bsStyle='link' style={{ padding: 0 }} disabled={this.props.recipientActive == false} onClick={this.handleShowNewNote}>Send New Note</Button>
                </Panel.Heading>

                <Panel.Body   >
                    {this.state.note.show == true && this.state.note.isReply == false && (
                        <Note
                            isReply={false}
                            fullName={fullName}
                            onSend={this.handleSendNote}
                            onCancel={this.handleCancelNote}
                        />
                    )}

                    {this.props.list.map((comm, index) =>
                        <div className='well' style={{ marginBottom: 10 }} key={`c-${index}`}>
                            {comm.sentByRecipient ?
                                <>
                                    <label className='control-label'>{fullName} wrote on {comm.sendDateTime}:</label>
                                    <div style={{ marginBottom: 10, marginLeft: 10 }}>{ReactHtmlParser(comm.note.replace('\n', '<br/>'))}</div>

                                    {comm.statusId == MicrositeRecipientCommunicationStatus.RepliedTo && (
                                        <div style={{ marginLeft: 20 }}>
                                            <label className='control-label'>You replied on {comm.replyDateTime}:</label>
                                            <div style={{ marginLeft: 10 }}>{ReactHtmlParser(comm.reply.replace('\n', '<br/>'))}</div>
                                        </div>
                                    )}

                                    {this.state.note.show == false && comm.statusId != MicrositeRecipientCommunicationStatus.RepliedTo && (
                                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Button bsStyle='primary' disabled={this.props.recipientActive == false} onClick={() => this.handleShowReply(comm.id)}>Reply</Button>
                                        </div>
                                    )}
                                </>
                                :
                                <>
                                    <label className='control-label'>You wrote on {comm.sendDateTime}:</label>
                                    <div style={{ marginBottom: 10, marginLeft: 10 }}>{ReactHtmlParser(comm.note.replace('\n', '<br/>'))}</div>

                                    {comm.statusId == MicrositeRecipientCommunicationStatus.Sent && (
                                        <div style={{ paddingTop: 20, textAlign: 'center' }}>
                                            <Label>Waiting for {fullName} to reply</Label>
                                        </div>
                                    )}

                                    {comm.statusId == MicrositeRecipientCommunicationStatus.RepliedTo && (
                                        <div style={{ marginLeft: 20 }}>
                                            <label className='control-label'>{fullName} replied on {comm.replyDateTime}:</label>
                                            <div style={{ marginLeft: 10 }}>{ReactHtmlParser(comm.reply.replace('\n', '<br/>'))}</div>
                                        </div>
                                    )}
                                </>
                            }

                            {this.state.note.show && this.state.note.itemId == comm.id && (
                                <Note
                                    isReply={true}
                                    fullName={fullName}
                                    onSend={this.handleSendNote}
                                    onCancel={this.handleCancelNote}
                                />
                            )}
                        </div>
                    )}

                    {this.props.list.length == 0 && (
                        <div>
                            Currently, there are no notes...
                        </div>
                    )}
                </Panel.Body>

            </Panel>
        );
    };
}

export default Communication;